import { SectionHead, Reveal, CountUp } from "./effects";

const metrics = [
  { value: 1, suffix: "M+", label: "Total Views", note: "Across YouTube, Reels & TikTok" },
  { value: 40, suffix: "+", label: "Projects Completed", note: "For creators, startups & brands" },
  { value: 98, suffix: "%", label: "Client Satisfaction", note: "Measured on delivery feedback" },
  { value: 4, suffix: "+", label: "Years Experience", note: "High-impact video editing" },
];

export const Results = () => (
  <section id="results" data-testid="results-section" className="relative py-24 sm:py-32 overflow-hidden">
    <div className="absolute inset-0 pointer-events-none">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[500px] w-[700px] rounded-full bg-[#D4AF37]/8 blur-[160px]" />
    </div>
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHead
        testId="results"
        eyebrow="Results That Matter"
        align="center"
        title={
          <>
            Numbers that speak <span className="text-gradient-blue">louder than promises</span>
          </>
        }
      />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {metrics.map((m, i) => (
          <Reveal key={m.label} delay={i * 0.1}>
            <div
              data-testid={`results-card-${m.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="group relative rounded-2xl border border-white/10 bg-[#0a0a0c] p-6 sm:p-8 text-center hover:border-[#D4AF37]/50 hover:shadow-[0_0_50px_rgba(212,175,55,0.18)] transition-all duration-500 overflow-hidden"
            >
              <div className="absolute -top-16 left-1/2 -translate-x-1/2 h-28 w-28 rounded-full bg-[#D4AF37]/20 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
              <div className="font-display text-4xl sm:text-5xl font-semibold text-white mb-2">
                <CountUp value={m.value} suffix={m.suffix} />
              </div>
              <div className="text-xs sm:text-sm font-medium text-slate-200 mb-1">{m.label}</div>
              <div className="text-[11px] text-slate-500">{m.note}</div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
